import React, { useEffect, useState } from 'react'
import { Button, Flex, Modal, Table } from 'antd'
import {
  CheckCircleOutlined,
} from '@ant-design/icons';
import { excelIcon } from '../../../../store/icons'
import { columns, columnsBrand, columnsCarLine, columnsErrorCar, columnsTypeCar, DataTypeError, tableColumnsFeedBack } from '../ColumnsDataError'
import { ColumnsType } from 'antd/es/table'

const exclamationIcon = <svg width="1em" height="1.028em" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18 5.42188C10.7789 5.42188 4.92188 11.2789 4.92188 18.5C4.92188 25.7211 10.7789 31.5781 18 31.5781C25.2211 31.5781 31.0781 25.7211 31.0781 18.5C31.0781 11.2789 25.2211 5.42188 18 5.42188ZM16.875 10.9062C16.875 10.7516 17.0016 10.625 17.1562 10.625H18.8438C18.9984 10.625 19.125 10.7516 19.125 10.9062V20.4688C19.125 20.6234 18.9984 20.75 18.8438 20.75H17.1562C17.0016 20.75 16.875 20.6234 16.875 20.4688V10.9062ZM18 26.375C17.5584 26.366 17.138 26.1842 16.8288 25.8687C16.5197 25.5533 16.3466 25.1292 16.3466 24.6875C16.3466 24.2458 16.5197 23.8217 16.8288 23.5063C17.138 23.1908 17.5584 23.009 18 23C18.4416 23.009 18.8621 23.1908 19.1712 23.5063C19.4803 23.8217 19.6534 24.2458 19.6534 24.6875C19.6534 25.1292 19.4803 25.5533 19.1712 25.8687C18.8621 26.1842 18.4416 26.366 18 26.375Z" fill="#FFF7E6" /> <path d="M18 2.75C9.30234 2.75 2.25 9.80234 2.25 18.5C2.25 27.1977 9.30234 34.25 18 34.25C26.6977 34.25 33.75 27.1977 33.75 18.5C33.75 9.80234 26.6977 2.75 18 2.75ZM18 31.5781C10.7789 31.5781 4.92188 25.7211 4.92188 18.5C4.92188 11.2789 10.7789 5.42188 18 5.42188C25.2211 5.42188 31.0781 11.2789 31.0781 18.5C31.0781 25.7211 25.2211 31.5781 18 31.5781Z" fill="#FA8C16" /> <path d="M17.1562 20.75H18.8438C18.9984 20.75 19.125 20.6234 19.125 20.4688V10.9062C19.125 10.7516 18.9984 10.625 18.8438 10.625H17.1562C17.0016 10.625 16.875 10.7516 16.875 10.9062V20.4688C16.875 20.6234 17.0016 20.75 17.1562 20.75ZM16.3125 24.6875C16.3125 25.1351 16.4903 25.5643 16.8068 25.8807C17.1232 26.1972 17.5524 26.375 18 26.375C18.4476 26.375 18.8768 26.1972 19.1932 25.8807C19.5097 25.5643 19.6875 25.1351 19.6875 24.6875C19.6875 24.2399 19.5097 23.8107 19.1932 23.4943C18.8768 23.1778 18.4476 23 18 23C17.5524 23 17.1232 23.1778 16.8068 23.4943C16.4903 23.8107 16.3125 24.2399 16.3125 24.6875Z" fill="#FA8C16" /> </svg>
interface Props {
  resource: {
    isSuccess: boolean;
    message: string;
    newlyCreatedRecords?: number;
    totalRecords?: number;
    unimportedRecords?: number
  }
  dataError: DataTypeError[]
  type: string
  fileData?: any
}

const ImportDataStep4V2: React.FC<Props> = ({
  resource, fileData, dataError, type
}) => {
  const [showImportDataModalCar, setShowImportDataModalCar] = useState(false)
  const [columnsData, setColumnsData] = useState<ColumnsType<DataTypeError> | undefined>()

  useEffect(() => {
    if (dataError?.length > 0) {
      switch (type) {
        case "dataCarError":
          setColumnsData(columnsErrorCar)
          break;
        case "dataColorCarError":
          setColumnsData(columns)
          break;
        case "dataTypeCarError":
          setColumnsData(columnsTypeCar)
          break;
        case "dataCategoryError":
          setColumnsData(columnsBrand)
          break;
        case "dataCarlineError":
          setColumnsData(columnsCarLine)
          break;
        case "dataFeedBackError":
          setColumnsData(tableColumnsFeedBack)
          break;
        default:
          setColumnsData(undefined)
          break;
      }
    }
  }, [dataError])

  return (
    <>
      <div className="import-data-step-4">
        <Flex vertical className='gap-24px'>
          <>
            {
              resource?.isSuccess ? (<div className="exclamation-block fsz-16 lh-24 font-medium sunset-orange-6 text-center">
                <CheckCircleOutlined />
                <div>
                  {resource?.message}
                </div>
              </div>)
                : (
                  <div className="exclamation-block fsz-16 lh-24 font-medium sunset-orange-6 text-center">
                    {exclamationIcon}
                    <div>
                      {resource?.message}
                    </div>
                  </div>
                )
            }
          </>
        </Flex>
        <div className='d-flex flex-column gap-4'>
          <div className='w-full p-3 bg-F2F4F7'>
            {fileData?.name ?
              <div className="item d-flex gap-2" >
                <span className="icon">{excelIcon}</span>
                <div className="title">{fileData?.name} </div>

              </div> : ""
            }
          </div>
          <div className='d-flex flex-column w-half'>
            <div className='d-flex justify-between'>
              <span className='text-sm text-667085'>Số lượng bản ghi</span>
              <span className='text-sm text-667085'>{resource?.totalRecords} </span>
            </div>
            <div className='d-flex justify-between'>
              <span className='text-sm text-667085'>Số lượng bản ghi tạo mới</span>
              <span className='text-sm text-667085'>{resource?.newlyCreatedRecords}/{resource?.totalRecords}</span>
            </div>
          </div>
          <div className='d-flex justify-between w-80-percent'>
            <div className='d-flex justify-between w-63-percent'>
              <span className='text-sm text-FF4D4F'>Số lượng bản ghi không import</span>
              <span className='text-sm text-FF4D4F '>{resource?.unimportedRecords}/{resource?.totalRecords}</span>
            </div>
            {
              (dataError ?? []).length > 0 && <span className='text-sm text-1890FF cursor-pointer' onClick={() => setShowImportDataModalCar(true)}>Xem chi tiết</span>
            }
          </div>
        </div>

      </div>
      <Modal
        open={showImportDataModalCar}
        title='Xem Chi tiết'
        className='rs-modal w-1216 footer-content-end'
        centered
        footer={[
          <Button
            type="primary"
            className="rs-button"
            onClick={() => setShowImportDataModalCar(false)}
          >Đóng</Button>
        ]}
        onCancel={() => setShowImportDataModalCar(false)}
      >
        <Table
          className='rs-table'
          rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
          rowKey="id"
          columns={columnsData}
          dataSource={dataError}
          showSorterTooltip={false}
          scroll={{ x: true }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10,
            showTotal: (total) => `Tổng cộng ${Math.ceil(total / 10)} trang`,
            locale: { items_per_page: ' / trang', jump_to: 'Tới' },
            position: ['bottomCenter'],
            className: 'rs-pagination',
            showQuickJumper: true,
          }}
        />
      </Modal>
    </>
  )
}

export default ImportDataStep4V2
